<mb-section-headline
  class="headline-container"
  *ngIf="data.headline || data.anchor"
  [headline]="data.headline"
  [anchor]="data.anchor"
  containerClass="container-sm"
></mb-section-headline>

<div class="container-xxl routes-container">
  <picture *ngIf="data.previewSmall || data.previewLarge" class="preview-picture">
    <source *ngIf="data.previewLarge" [srcset]="data.previewLarge" media="(min-width: 786px)" />
    <img [src]="data.previewSmall || data.previewLarge" alt="map" />
  </picture>
  <div class="collection-wrapper">
    <div class="container-sm collection-wrapper-container">
      <div class="route-collection-container">
        <div *ngFor="let collection of data.routes" class="route-collection-item">
          <a class="btn btn-plain" [routerLink]="['test-routes', data.id]" [queryParams]="{ day: collection.day }">{{
            'DAY_N' | translate: { day: collection.day }
          }}</a>

          <span class="mb-badge mb-badge-small">{{ collection.routeCount }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
